<p-toast></p-toast>
<app-spinner></app-spinner>
<div class="card">
  <ng-container *ngIf="dataTable.length > 0; else no_survey_found">
    <p-table
      #surveyTable
      [columns]="dataColumn"
      [value]="dataTable"
      dataKey="id"
      *ngIf="dataTable"
      styleClass="p-datatable-responsive-demo"
      [paginator]="true"
      [rows]="5"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
      [rowsPerPageOptions]="[5, 10, 50]"
      [globalFilterFields]="['name', 'description', 'isActive']"
    >
      <ng-template pTemplate="caption">
        <div class="p-d-flex">
          <span class="p-input-icon-left p-ml-auto">
            <i class="pi pi-search"></i>
            <input
              pInputText
              type="text"
              (input)="surveyTable.filterGlobal($event.target.value, 'contains')"
              placeholder="Search keyword"
            />
          </span>
        </div>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th pSortableColumn="name">
            <p-sortIcon field="name"></p-sortIcon>
            Name
          </th>
          <th pSortableColumn="studyName">Study</th>
          <th>Description</th>
          <th pSortableColumn="isActive">
            <p-sortIcon field="isActive"></p-sortIcon>
            Is Active
          </th>
          <th pSortableColumn="createdAt">
            <p-sortIcon field="createdAt"></p-sortIcon>
            Start-date
          </th>
          <th>Edit</th>
          <th>Delete</th>
          <th>Clone</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData>
        <tr (click)="openDetailSurvey(rowData)">
          <td>{{ rowData.name }}</td>
          <td>{{ rowData.studyName }}</td>
          <td>{{ rowData.description }}</td>
          <td>{{ rowData.isActive }}</td>
          <td>{{ rowData.startdate?.seconds * 1000 | date: 'short' }}</td>
          <td>
            <button
              pButton
              pRipple
              type="button"
              icon="pi pi-pencil"
              (click)="openEditForm(rowData); $event.stopPropagation()"
              class="p-button-rounded p-button-text"
            ></button>
          </td>
          <td>
            <button
              pButton
              pRipple
              type="button"
              icon="pi pi-trash"
              (click)="deleteSurvey(rowData); $event.stopPropagation()"
              class="p-button-rounded p-button-text"
            ></button>
          </td>
          <td>
            <button
              pButton
              pRipple
              (click)="cloneQuestionForm(rowData); $event.stopPropagation()"
              type="button"
              icon="pi pi-copy"
              class="p-button-rounded p-button-text"
            ></button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </ng-container>
  <ng-template #no_survey_found>
    <div class="noProductFound d-flex-col d-flex-centre">
      <span> No survey found with the given name. </span>
      <img src="../../../assets/images/core/not-found.png" />
    </div>
  </ng-template>
</div>
